import { render } from "./SubMenu.vue?vue&type=template&id=46dadcfd&scoped=true"
import script from "./SubMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMenu.vue?vue&type=script&setup=true&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=46dadcfd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dadcfd"],['__file',"resources/js/base/components/header-controls/SubMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46dadcfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46dadcfd', __exports__)) {
    api.reload('46dadcfd', __exports__)
  }
  
  module.hot.accept("./SubMenu.vue?vue&type=template&id=46dadcfd&scoped=true", () => {
    api.rerender('46dadcfd', render)
  })

}


export default __exports__